<h1 class="center mt-3 payment-success-title">Order Completed</h1>
<h3 class="center mt-3 payment-success-title">
    You will be receiving an email with details of your purchased services
</h3>
<mat-divider class="center-p"></mat-divider>
<p class="center-p mt-3 payment-success-text">
Please be aware that if you purchased your appointment after hours, on a holiday, or on a weekend, that you may not hear from your provider until the following business day.
We're currently upgrading our software so that, very soon, you can purchase care via every provider's exact available dates and time slots.  Keep supporting us and we'll get there.
</p>
<mat-divider class="center-p mb-4"></mat-divider>

<mat-card style="overflow: hidden;  border-radius: 4px;" class="center">
    <table
        class="mt-2"
        mat-table
        [dataSource]="completedOrder.orderServicePlanModel"
    >
        <ng-container matColumnDef="Description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">
                {{ element.servicePlan.description }}
            </td>
        </ng-container>

        <ng-container matColumnDef="Rate">
            <th mat-header-cell *matHeaderCellDef>Rate</th>
            <td mat-cell *matCellDef="let element">
                ${{ element.servicePlan.rate?.toFixed(2) }}
            </td>
        </ng-container>

        <ng-container matColumnDef="Appointment Type">
            <th mat-header-cell *matHeaderCellDef>Appointment Type</th>
            <td mat-cell *matCellDef="let element">
                {{ element.servicePlan.appointmentType }}
            </td>
        </ng-container>

        <ng-container matColumnDef="Quantity Requested">
            <th mat-header-cell *matHeaderCellDef>Quantity Requested</th>
            <td mat-cell *matCellDef="let element">{{ element.quantity }}</td>
        </ng-container>

        <ng-container matColumnDef="Total Cost">
            <th mat-header-cell *matHeaderCellDef>Total Cost</th>
            <td mat-cell *matCellDef="let element">
                ${{ element.total?.toFixed(2) }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</mat-card>

<div class="checkout-box">
    <div class="checkout-box-components">
        Total Paid: <strong>${{ completedOrder.total?.toFixed(2) }}</strong>
    </div>

    <mat-divider></mat-divider>
</div>
